import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmationService, Message, MessageService } from 'primeng/api';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { MessagesModule } from 'primeng/messages';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { IpAddressService } from 'src/app/services/ip-address.service';

@Component({
  selector: 'app-kyc',
  templateUrl: './kyc.component.html',
  styleUrls: ['./kyc.component.scss'],
  // imports: [MessagesModule]
})
export class KycComponent implements OnInit {

  @Output() kycStatusEvent = new EventEmitter<string>();
  
  public showKYCPopUpDialog = false;
  public farmerAadharNumber: any;
  public consentCheckboxValue: any;

  public showStatusMessage: boolean = false;
  public isErrorStatus: boolean = false;
  public statusMessageText: any;

  public memberIdOTPValue: any;

  public isMemberOTPSent: boolean = false;
  
  public pppIDData: any;
  public openPPIDDataCard: boolean = false;

  public aadharConsentCheckboxValue: any;

  public isAadharOTPSent: boolean = false;
  public aadharOTPValue: any;
  public isAadharVerified: boolean = false;

  public isKYCCompleted: boolean = false;
  public showAadharOTPStatusMsg: boolean = false;


  //need to remove
  fetchedFamilyData: any;
  fetchedMemberId: any;
  fetchedFamilyId: any;

  @Input() farmerDetails;

  messages: Message[] | undefined;
  displayErrorPopUp: boolean = false;
  
  public showTextField: boolean = false;
  public aadharNumber: any = null;
  public farmerId: any = null;
  public memberIdForNewUser: any = null;
  public autoIdForNewUser: any = null;
  ipAddress: any = '000.000.000';
  farmersDetailsForm: FormGroup;
  isSubmitted: boolean = false;
  // farmerMobNo: any;

  villageList: { Code: number, Name: string }[];
  filteredVillage: any[];
  
  constructor(
    private _fb: FormBuilder,
    private loader: AppLoaderService,
    private _personalDetalSer: FarmersDetailsService,
    private messageService: MessageService, 
    private confirmationService: ConfirmationService,
    private cryptoJsService: CryptoJsService,
    private activityRecordService: ActivityRecordService,
    private ipService: IpAddressService,
  ) { }

  ngOnInit(): void {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    // this.farmerMobNo = farmerconfData.get('farmerPh');
    
    this.getIP();
    if(this.farmerDetails != null){
      // this.aadharNumber = this.farmerDetails.Aadhar_No;
      if(this.farmerDetails?.AadharStatus == false){
        if(this.farmerDetails?.Farmer_ID == null){
          this.farmerId = null;

          this.isKYCCompleted = false;
          this.showTextField = true;
        }else if(this.farmerDetails?.Farmer_ID != null){
          this.farmerId = this.farmerDetails?.Farmer_ID;

          this.loadPersonalDetails();
          this.isKYCCompleted = false;
          this.showTextField = false;
        }
      }else if(this.farmerDetails?.AadharStatus == true){
        this.farmerId = this.farmerDetails?.Farmer_ID;;

        this.isKYCCompleted = true;
      }

      // if(this.farmerDetails?.AadharStatus == false && this.farmerDetails?.Farmer_ID != null){
      //   this.loadPersonalDetails();
      //   this.isKYCCompleted = false;
      //   this.showTextField = false;
      // }else if(this.farmerDetails?.AadharStatus == false && this.farmerDetails?.Farmer_ID == null){
      //   this.isKYCCompleted = false;
      //   this.showTextField = true;
      // }
      // this.aadharNumber = '200411089222';
      // this.farmerId = null;
      // if(this.farmerDetails?.AadharStatus && this.farmerDetails?.AadharStatus == true){
      //   this.isKYCCompleted = true;
      // }
      // else{
      //   this.isKYCCompleted = false;
      //   // this.showTextField = true;
      //   this.showTextField = false;
      // }
    }else{
      this.isKYCCompleted = false;
      this.showTextField = true;
    }

    this.farmersDetailsForm = this._fb.group({
      farmerMobNo: [
      { value: '', disabled: false },
      [
        Validators.required,
        Validators.pattern(/^[0-9]{10}$/),
        Validators.minLength(10),
        Validators.maxLength(10)
      ]
      ],
      farmersPhotoPath: ['', Validators.required],
      mfmbNo: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(8)]],
      village: ['', Validators.required],
    });

    this.getVillageList();
  }

  get farmersFormControls() {
    return this.farmersDetailsForm.controls;
  }

  hideKYCDialog(){

  }

  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);
    // let phNo = this.farmerMobNo;
    let phNo = this.aadharNumber;
    this._personalDetalSer.uploadFile(data, phNo, formcontrol).subscribe((resp: any) => {
      if (resp.statusCode == 200) {
        this.farmersDetailsForm.patchValue({ [formcontrol]: resp.data });
      }
    })
    uploadElement.clear();
  }

  onSubmitConsent(){
    this.consentCheckboxValue = false;
    this.showStatusMessage = true;
    this.getMemberIdFromUID();
  }

  addNewItem(value: string) {
    this.kycStatusEvent.emit(value);
  }

  getIP() {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerConfData = new Map(encData);
    let ipAddress = farmerConfData.get('ipAddress');

    if (ipAddress) {
      this.ipAddress = ipAddress;
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;

        farmerConfData.set('ipAddress', this.ipAddress)

        const dataF = JSON.stringify(Array.from(farmerConfData.entries()));
        sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));  
      });
    }
  }

  getMemberIdFromUID(){
    this.loader.start();
    // let aadharNo = this.cryptoJsService.Encrypt(this.farmerDetails.Aadhar_No);
    // let farmerId = this.cryptoJsService.Encrypt(this.farmerDetails.Farmer_ID);
    this._personalDetalSer.getFamilyIdByUID(this.aadharNumber, this.farmerId).pipe(first())
    // this._personalDetalSer.getFamilyIdByUID(aadharNo, farmerId).pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          // if (data.message == "Record Match") {
          // if (data == "Record mismatched") {
          // if (data == "OTP Sent to registered mobile No.") {
          if(this.farmerId == null) {
            if (data.Msg.startsWith('OTP Sent to')) {

              this.memberIdForNewUser = data?.MemberId;
              this.isMemberOTPSent = true;
              this.isErrorStatus = false;
              this.statusMessageText = `${data.Msg}.`
              this.showTextField = false;
  
            } else {
  
              this.displayErrorPopUp = true;
  
              this.isMemberOTPSent = false;
              this.isErrorStatus = true;
              this.statusMessageText = `${data.Msg}. Please try again.`
            }
          }else{
            if (data.Msg.startsWith('OTP Sent to')) {

              this.isMemberOTPSent = true;
              this.isErrorStatus = false;
              this.statusMessageText = `${data.Msg}.`
  
              // this.messageService.add({ severity: 'success', summary: 'OTP Sent', detail: data });
              
              // this.isErrorStatus = false;
              // this.statusMessageText = 'PPP Id fetched from Aadhar Number. Verifying it...'
  
              // this.fetchedFamilyData = data.result[0];
              // this.fetchedMemberId = this.fetchedFamilyData.memberid;
              // this.fetchedFamilyId = this.fetchedFamilyData.familyid;
  
              // this.verifyPPPId(this.farmerDetails.Farmer_ID, this.fetchedFamilyId);
  
            } else {
  
              this.displayErrorPopUp = true;
  
              this.isMemberOTPSent = false;
              this.isErrorStatus = true;
              this.statusMessageText = `${data.Msg}. Please try again.`
  
              // this.messageService.add({ severity: 'error', summary: 'OTP Not Sent', detail: data });
            }
          }
        },
        error: (err) => {
          this.loader.close();

          this.displayErrorPopUp = true;

          this.isMemberOTPSent = false;
          this.isErrorStatus = true;
          this.statusMessageText = `${err}. Please try again.`

          // this.messageService.add({ severity: 'error', summary: 'OTP Not Sent', detail: err });

          // this.isErrorStatus = true;
          // this.statusMessageText = `${err}. Please try again.`

          // this.loader.close();
          // this.messageService.add({ severity: 'error', summary: '11Error Message', detail: err });
        }
      });
  }

  verifyPPPId(farmerId, familyId){
    this.loader.start();
    this._personalDetalSer.getVerifyPPPID(farmerId, familyId).pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          data = data[0].Column1;
          if(data == "Record not matched"){

            this.isErrorStatus = false;
            this.statusMessageText = data;

            this.sendOTPforMEMID();
            // this.messageService.add({ severity: 'success', summary: 'Success', detail: data });
          }else{
            this.displayErrorPopUp = true;

            this.isErrorStatus = true;
            this.statusMessageText = `${data}. Please try again.`

            // this.messageService.add({ severity: 'error', summary: 'Error', detail: data });
          }
        },
        error: (err) => {
          this.displayErrorPopUp = true;

          this.loader.close();
          this.isErrorStatus = true;
          this.statusMessageText = `${err}. Please try again.`

          // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
        }
      });
  }

  sendOTPforMEMID (){
    this.loader.start();
    this._personalDetalSer.OTPRequestforMEMID(this.fetchedMemberId).pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          // if(data == "OTP Sent to registered mobile No."){
          if(data.startsWith('OTP Sent to')){
              this.isMemberOTPSent = true;

            this.isErrorStatus = false;
            this.statusMessageText = data;

            // this.messageService.add({ severity: 'success', summary: 'OTP Sent', detail: data });
          }else{

            this.displayErrorPopUp = true;

            this.isMemberOTPSent = false;
            this.isErrorStatus = true;
            this.statusMessageText = `${data}. Please try again.`

            // this.messageService.add({ severity: 'error', summary: 'OTP Not Sent', detail: data });
          } 
        },
        error: (err) => {
          this.displayErrorPopUp = true;

          this.loader.close();
          // this.openPPIDDialog = false;
          
          this.isMemberOTPSent = false;
          this.isErrorStatus = true;
          this.statusMessageText = `${err}. Please try again.`

          // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
        }
      });
  }

  onSubmitMemIdOTP(){
    // let farmerId = this.cryptoJsService.Encrypt(this.farmerDetails.Farmer_ID);
    // let memberIdOTP = this.cryptoJsService.Encrypt(this.memberIdOTPValue)
    this.loader.start();
    // this._personalDetalSer.verifyOTPRequestForMID(farmerId, memberIdOTP).pipe(first())
    this._personalDetalSer.verifyOTPRequestForMID(this.farmerId, this.memberIdForNewUser, this.memberIdOTPValue).pipe(first())
      .subscribe({
        next: (data) => {
          this.autoIdForNewUser = data?.AutoId;
          data = JSON.parse(data.Data)
          this.loader.close();
       
          if(data.message == "Record Match"){
          // if(data.message == "Please enter transaction ID"){
            this.isErrorStatus = false;
            this.statusMessageText = data.message;
            
            this.pppIDData = data.result;

            // this.farmerMobNo = this.pppIDData?.mobileNo;
            this.farmersDetailsForm.controls['farmerMobNo'].setValue(this.pppIDData?.mobileNo);

            this.openPPIDDataCard = true;

            // this.messageService.add({ severity: 'success', summary: data.status , detail: data.message });
          }else{
            
            this.displayErrorPopUp = true;

            this.openPPIDDataCard = false;

            this.isErrorStatus = true;
            this.statusMessageText = `${data.message}. Please try again.`

            // this.messageService.add({ severity: 'error', summary: data.status , detail: data.message });

          }
        },
        error: (err) => {
          this.loader.close();

          this.displayErrorPopUp = true;
          this.isErrorStatus = true;
          this.statusMessageText = `${err}. Please try again.`

          this.openPPIDDataCard = false;

          // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });
        }
      });
  }

  onSubmitAadharConsent(){
    this.isSubmitted = true;
    if(this.farmerId == null){
      if(!this.farmersDetailsForm.valid){
        Object.keys(this.farmersDetailsForm.controls).forEach(field => {
          const control = this.farmersDetailsForm.get(field);
          if (control && control.invalid) {
            let val = '';
            if(field == 'village'){
              val = 'Invalid field! Select Village';
            }
            else if(field == 'farmersPhotoPath'){
              val = 'Invalid field! Upload Farmer Photo'
            }else if(field == 'mfmbNo'){
              val = 'Invalid field! Enter MFMB No'
            }else if(field == 'farmerMobNo'){
              val = 'Invalid phone Number! Enter valid Mobile No'
            }
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: val });
          }
        });
        return;
      }
    }
    this.validateAadharNumber(this.aadharNumber);
    this.isAadharOTPSent = true;
  }
    
  submitPersonlDetails(){
    let reqBody = {
      farmerID:  '',
      ppP_ID: this.pppIDData?.familyID,
      farmerphoto_path: this.farmersDetailsForm.value?.farmersPhotoPath,
      casteCertificate_Path: '',
      name: this.pppIDData?.fullName,
      farmerFatherName: this.pppIDData?.fatherFullName,
      farmerMotherName: this.pppIDData?.motherFullName,
      address: `House No: ${this.pppIDData?.houseNo}, Street No ${this.pppIDData?.streetNo}, LandMark ${this.pppIDData?.address_LandMark},  ${this.pppIDData?.districtName}.`,
      mobileno: this.farmersDetailsForm.value?.farmerMobNo,
      ppP_path: '',
      dob: this.pppIDData?.dob,
      pincode: this.pppIDData?.pinCode,
      emailid: '',
      aadharno: this.aadharNumber,
      aadhar_path: '',
      castcode: this.pppIDData?.casteCategoryName.startsWith('GEN') ? 1 : this.pppIDData?.casteCategoryName.startsWith('BC') ? 1 : this.pppIDData?.casteCategoryName.startsWith('S') ? 3 : 0,
      gender: this.pppIDData?.gender,
      // villagecode: this.pppIDData?.wvCodeLGD ? this.pppIDData?.wvCodeLGD : '0',
      villagecode: this.farmersDetailsForm.value.village?.Code,
      mfmbNo: this.farmersDetailsForm.value?.mfmbNo,
      idproof: "aadhar",
      active: '1',
      userID : 'farmer',
      area_Already_Apply: 0,
      fid: '0',
      network_ID: this.ipAddress,
      terminal_ID: this.ipAddress,
      is_Atal: false,
      isAutomatedData: 1,
      autoId: this.autoIdForNewUser ? this.autoIdForNewUser : 0,
      memberId: this.memberIdForNewUser
    }

    this._insert(reqBody);
  }

  _insert(data_) {
    let phNo = this.aadharNumber;

    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(data_))
    }

    this.loader.start();
    // let reqBody = this.cryptoJsService.EncryptPayload(data_)
    this._personalDetalSer.postFarmersData(reqBodyFinal).pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data == "Farmer Details Saved Successfully! ") {
            this.isKYCCompleted = true;

            let reqBody = {
              MobileNo : data_?.mobileno,
            }
        
            let reqBodyAfterEncypt = {
              "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
            }

            this._personalDetalSer.getFarmerDetails(reqBodyAfterEncypt)
              .pipe(first())
              .subscribe({
                next: (resp) => {
                  let data = JSON.parse(this.cryptoJsService.DecryptToken(resp.data));

                  if (data) {

                    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
                    const farmerconfData = new Map(encData);

                    farmerconfData.set('farmerDetails', data[0]);
                    farmerconfData.set('AadharStatus_', data[0]?.AadharStatus);
                    farmerconfData.set('Farmer_Id_', data[0]?.Farmer_ID);                   
                    farmerconfData.set('farmerPh', data[0]?.Mobile);

                    const dataF = JSON.stringify(Array.from(farmerconfData.entries()));
                    sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));

                    setTimeout(()=> {
                      location.reload();
                    }, 1500) 
                  }
                }
              });

            // this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Farmer Details saved Successfully.' });
          } else {
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: data });
          }

          this.activityRecordService.activityRecord(phNo, 'Insert Personal Details (auto mode)', '', new Date(), data, data_);

        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(phNo, 'Insert Personal Details (auto mode)', '', new Date(), err, data_);
          this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

        }
      });
  }

  validateAadharNumber(aadharNumber){
    // let aadharNo = this.cryptoJsService.Encrypt(aadharNumber);
    this.loader.start();
    // this._personalDetalSer.validateAadhar(aadharNo).pipe(first())

    let reqBody = {
      "AadharNo": aadharNumber
    };

    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }
    this._personalDetalSer.validateAadhar(reqBodyAfterEncypt).pipe(first())
      .subscribe({
        next: (data) => {
          this.showAadharOTPStatusMsg = true;
          this.loader.close();

          if (data == "OTP sent") {
            // if (data == "Invalid Aadhaar Number") {

            this.isErrorStatus = false;
            this.statusMessageText = `${data}`

            this.isAadharOTPSent = true;
            
            // this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'OTP Sent Successfully.' });
          } else {

            this.displayErrorPopUp = true;

            this.isErrorStatus = true;
            this.statusMessageText = `${data}. Please try again.`
            this.isAadharOTPSent = false;

            // this.messageService.add({ severity: 'info', summary: 'Info Message', detail: data });
          }

          this.activityRecordService.activityRecord(aadharNumber, 'Validate Aadhar Number', '', new Date(), data, aadharNumber);
        },
        error: (err) => {
          this.loader.close();

          this.displayErrorPopUp = true;
          this.isAadharOTPSent = false;
          this.isErrorStatus = true;
          this.statusMessageText = `${err}. Please try again.`

          // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          this.activityRecordService.activityRecord(aadharNumber, 'Validate Aadhar Number(error)', '', new Date(), err, aadharNumber);
        }
      });
  }

  onSubmitAadharOTP(){
    this.validateAadharOTP(this.aadharNumber, this.aadharOTPValue);
  }

  validateAadharOTP(aadharNumber, otp){
    // let aadharNo = this.cryptoJsService.Encrypt(aadharNumber);
    // let aadharOTP = this.cryptoJsService.Encrypt(otp);
    this.loader.start();
    // this._personalDetalSer.validateOTP(aadharNo, aadharOTP).pipe(first())
    let memberId = '';
    if(this.farmerDetails == null){
      memberId = this.memberIdForNewUser;
    }
    this._personalDetalSer.validateOTP(aadharNumber, otp, memberId).pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data.startsWith('success') || data.startsWith('Success')) {
            if(this.farmerId == null){
              this.submitPersonlDetails();
            }else{
              this.isKYCCompleted = true;
            }
            
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Aadhar Validated Successfully.' });
          } else {

            this.displayErrorPopUp = true;
            this.isKYCCompleted = false;
            this.isErrorStatus = true;
            this.statusMessageText = `${data}. Please try again.`

            // this.messageService.add({ severity: 'info', summary: 'Info Message', detail: data });
          }

          this.activityRecordService.activityRecord(aadharNumber, 'Validate OTP For Aadhar Verification', '', new Date(), data, aadharNumber);
        },
        error: (err) => {
          this.loader.close();
          this.displayErrorPopUp = true;
          this.isKYCCompleted = false;

          this.isErrorStatus = true;
          this.statusMessageText = `${err}. Please try again.`

          // this.messageService.add({ severity: 'error', summary: 'Error Message', detail: err });

          this.activityRecordService.activityRecord(aadharNumber, 'Validate OTP For Aadhar Verification(error)', '', new Date(), err, aadharNumber);
        }
      });
  }

  hideErrorDialog() {
    this.displayErrorPopUp = false;
  }

  getVillageList(){
    this._personalDetalSer
    .getVillageMatserData()
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.villageList = res;
          this.filteredVillage = [...this.villageList]

          if (!window.localStorage.getItem("villageMaster")) {
            window.localStorage.setItem("villageMaster", JSON.stringify(res));
          }
        },
        error: (err) => {},
      });
  }

  filterVillage(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.villageList.length; i++) {
      const village = this.villageList[i];
      if (village.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(village);
      }
    }
    this.filteredVillage = filtered;
  }

  loadPersonalDetails() {
    this.loader.start();
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    let phNo = farmerconfData.get('farmerPh') ? farmerconfData.get('farmerPh') : '';
    
    let reqBody = {
      MobileNo : phNo
    }

    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    let sub = this._personalDetalSer
      .getFarmerDetails(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          this.loader.close();
          let data = JSON.parse(this.cryptoJsService.DecryptToken(resp.data));

          if (data) {
            let farmerData = data[0];
            if (farmerData) {
              
              this.aadharNumber = farmerData?.Aadhar_No;
              this.farmerId = farmerData?.Farmer_ID;

              const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
              const farmerconfData = new Map(encData);

              farmerconfData.set('farmerDetails', data[0]);

              const dataF = JSON.stringify(Array.from(farmerconfData.entries()));
              sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));
            }
          }  
        },
        error: (err) => {
          this.loader.close();
          
        },
      });

    // this.subscriptions.push(sub);
  }
}